var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticStyle:{"text-decoration":"none"},attrs:{"href":"/admin?tab=bookings&status=Pending Verification"}},[_c('v-alert',{attrs:{"outlined":"","type":"info"}},[_vm._v(_vm._s(_vm.pendingText))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }